module.exports = __webpack_public_path__ + "img/rku10-3.32e6268e.png";